// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbsContainerArcade":"breadcrumbs_breadCrumbsContainerArcade__N4KBE","breadCrumbsContainer":"breadcrumbs_breadCrumbsContainer__YoYLH"};